import React, { useEffect } from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ProviderMatchProviderV9, PMCConfig } from '@kyruus/types';

import {
  CardContentContainer,
  CardContentAnchor,
  CardContentHeader,
  ProviderInformationCard
} from './styles';
import { isSummaryDataConfigured, pruneIgnoredValues } from '../../lib/utils';
import messages from '../../lib/messages';
import { PROFILE_SECTION_IDS } from '../../lib/constants';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';

const InsurancePlans = ({
  provider,
  config,
  shouldSkipRender,
  intl,
  shouldHidePageAnchors
}: {
  provider: ProviderMatchProviderV9;
  config: PMCConfig;
  shouldHidePageAnchors: boolean;
  shouldSkipRender: (component: string) => void;
} & WrappedComponentProps): React.ReactElement | null => {
  const prunedProvider = pruneIgnoredValues(
    provider,
    'insurance_accepted',
    config
  );

  const skipRendering =
    !isSummaryDataConfigured('insurance_accepted', config) ||
    !Array.isArray(prunedProvider.insurance_accepted) ||
    prunedProvider.insurance_accepted.length === 0;

  useEffect(() => {
    if (skipRendering) {
      // callback to the parent component to skip rendering
      shouldSkipRender('insurance-plans');
    }
  }, [skipRendering]);

  // do not render if summary_data field not present or data not present or is empty
  if (skipRendering) {
    return null;
  }

  return (
    <ProviderInformationCard data-testid="info-card-insurance-plans">
      <CardContentContainer>
        <CardContentHeader>
          {intl.formatMessage(messages.insurancePlansUnfacetedHeader)}
        </CardContentHeader>
        {!shouldHidePageAnchors && (
          <CardContentAnchor
            href={'#' + PROFILE_SECTION_IDS.INSURANCE_ACCEPTED}
          >
            {intl.formatMessage(messages.informationCardInsurancesViewAll, {
              numInsurances: prunedProvider.insurance_accepted.length
            })}
          </CardContentAnchor>
        )}
      </CardContentContainer>
    </ProviderInformationCard>
  );
};

export default withErrorBoundary(injectIntl(InsurancePlans));
